const contactBackLink = document.querySelector('[data-contact-history-back]');

contactBackLink?.addEventListener('click', (event) => {
  if (window.history.length <= 1 || !document.referrer) return;

  try {
    const previousUrl = new URL(document.referrer);
    const currentUrl = new URL(window.location.href);

    if (previousUrl.origin !== currentUrl.origin || previousUrl.pathname === currentUrl.pathname) return;

    event.preventDefault();
    window.history.back();
  } catch (_error) {
    // The homepage href remains the safe fallback.
  }
});
